// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom/client';
import _ from 'underscore';

import {maybeShowBadAlignmentError} from 'analyses/alignment/AlignmentActions';
import CreateSequenceAlignmentsModal from 'analyses/alignment/modals/CreateSequenceAlignmentsModal';
import {InputType} from 'analyses/alignment/modals/createSequenceAlignmentsModalReducer';
import {AlignmentAnalysis} from 'analyses/Analyses';
import * as analytics from 'analytics/Analytics';
import {track} from 'analytics/Analytics';
import {Sequence} from 'components/Sequence';
import * as SequenceAnalysisConstants from 'constants/SequenceAnalysisConstants';
import {AlignmentPanelState, InProgressAlignment} from 'FileStates';
import SequenceAlignmentTabState from 'molbio/tabstates/SequenceAlignmentTabState';
import ToolbarSignupMessage from 'nav/share/growth/ToolbarSignupMessage';
import {showValueMessagingForSharedFile} from 'nav/share/growth/Util';
import {BufferStates} from 'Navigation';
import notifications from 'notifications';
import * as popup from 'Popup';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';
import {AlignmentProgressProps} from 'toolbar/AlignmentProgressTemplate';
import AlignmentProgressTemplate from 'toolbar/AlignmentProgressTemplate';
import AlignmentRowTemplate, {AlignmentRowProps} from 'toolbar/AlignmentRowTemplate';
import {renderSinglePanelTab} from 'toolbar/shared/PanelUtil';
import legacyRunModal from 'ui-library/legacyRunModal';
import * as DateUtil from 'util/DateUtil';

export function _canDeleteAlignments(sequence: Sequence): boolean | undefined {
  return sequence.get('permissions').polymerFeaturesEditable;
}

export interface AlignmentItemViewOptions extends Backbone.ViewOptions<AlignmentAnalysis> {
  checkDelete: (analysis: AlignmentAnalysis) => SequenceAlignmentTabState | null;
}

export class AlignmentItemView extends Backbone.View<AlignmentAnalysis> {
  checkDelete!: (analysis: AlignmentAnalysis) => SequenceAlignmentTabState | null;
  template!: (props: AlignmentRowProps) => string;

  static initClass(): void {
    this.prototype.template = AlignmentRowTemplate;
    this.prototype.tagName = 'tr';
    this.prototype.className = 'panel-library-row';
  }

  override events(): Backbone.EventsHash {
    return {
      click: 'openAlignment',
      'click .delete': 'deleteAlignment',
    };
  }

  override initialize(options: AlignmentItemViewOptions): void {
    this.checkDelete = options.checkDelete;
  }

  openAlignment(e: JQueryEventObject): void {
    // Don't go through if triggered from delete icon.
    if ($(e.target).hasClass('delete')) {
      return;
    }
    this.model.trigger('openAlignment', this.model);
  }

  deleteAlignment(): void {
    // Duplicated in restriction panel.
    const tab = this.checkDelete(this.model);
    const alignmentName = _.escape(this.model.get('name'));

    function destroyCallback(): JQueryPromise<void> {
      analytics.track('alignment', 'delete_alignment');
      // @ts-expect-error shadow outer this
      return this.model
        .destroy()
        .fail(() => {
          notifications.error('An error occurred while trying to delete the alignment.');
        })
        .done(() => {
          notifications.success(
            <>
              Sequence alignment <strong>{alignmentName}</strong> successfully deleted.
            </>
          );
          // @ts-expect-error shadow outer this
          this.remove();
          if (tab != null) {
            tab.close();
          }
        });
    }

    // @ts-expect-error TS also does not like func-assign
    // eslint-disable-next-line no-restricted-syntax, no-func-assign
    destroyCallback = _.bind(destroyCallback, this);
    const confirmMessage =
      tab == null
        ? `Are you sure you want to delete <b>${alignmentName}</b>?`
        : `<b>${alignmentName}</b> is currently open in a tab - are you sure you want to delete it and close its tab?`;

    new popup.Confirm({title: 'Confirm Deleting Alignment', msg: confirmMessage})
      .choice('Delete', 'btn-af-danger', destroyCallback)
      .choice('Cancel', 'btn-af-default')
      .show();
  }

  override render(): this {
    const d = new Date(this.model.get('created_at'));
    this.$el.html(
      this.template({
        name: this.model.get('name'),
        time: DateUtil.readableTime(d),
      })
    );
    return this;
  }
}
AlignmentItemView.initClass();

class AlignmentPanelView extends Backbone.View<Backbone.Model> {
  alignmentProgressTemplate!: (props: AlignmentProgressProps) => string;
  buffers!: BufferStates;
  panelState!: AlignmentPanelState | null;
  sequence!: Sequence | null;
  sort!: (one: AlignmentAnalysis, two: AlignmentAnalysis) => number;

  singlePanelTabReactRoot: ReactDOM.Root | null = null;
  toolbarSignupMessageReactRoot: ReactDOM.Root | null = null;

  static initClass(): void {
    this.prototype.el = '#alignment-panel';
  }

  override events(): Backbone.EventsHash {
    return {
      'click .new-alignment-btn': 'openModal',
      'click .js-alignment-sort': 'sortAlignments',
    };
  }

  override initialize(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.sort = this.sortByName;
    this.alignmentProgressTemplate = AlignmentProgressTemplate;
  }

  openModal(): void {
    if (window.user == null) {
      // @ts-expect-error window.location is supposed to be read-only
      window.location = '/signup';
      return;
    }
    track('alignment', 'openModal', {source: 'alignment-panel'});

    legacyRunModal(CreateSequenceAlignmentsModal, {
      initialInputs: [
        {
          type: InputType.BIOENTITY,
          name: this.sequence!.name(),
          id: this.sequence!.get('id'),
          canBeTemplate: this.sequence!.permissions().polymerFeaturesEditable!,
          useCurrentVersion: true,
          nucleotideType: this.sequence!.nucleotideType(),
        },
      ],
    });
  }

  update(state: AlignmentPanelState, sequence: Sequence): void {
    if (this.panelState != null) {
      this.stopListening(this.panelState);
      this.stopListening(this.panelState.get('alignmentsInProgress'));
    }
    if (this.sequence != null) {
      this.stopListening(this.sequence.get('_sequence'));
      this.stopListening(this.sequence.get('analyses'));
    }
    this.panelState = state;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.panelState.get('alignmentsInProgress'), 'add remove change', this.renderInProgress);
    if (this.sequence != null) {
      this.stopListening(this.sequence.get('analyses'));
    }
    this.sequence = sequence;
    this.buffers = state.get('buffers');
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.sequence, 'change:writable change:permissions change:currentVersion', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.sequence.get('_sequence'), 'change:finalized', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.sequence.get('analyses'), 'add remove change reset', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.sequence.get('analyses'), 'openAlignment', this.openAlignment);
    this.render();
  }

  sortByName(one: AlignmentAnalysis, two: AlignmentAnalysis): number {
    const rv = one.get('name').localeCompare(two.get('name'));
    if (rv !== 0) {
      return rv;
    }
    return two.get('id') - one.get('id');
  }

  sortByDate(one: AlignmentAnalysis, two: AlignmentAnalysis): number {
    return two.get('id') - one.get('id');
  }

  sortAlignments(e: JQueryEventObject): void {
    const $el = this.$(e.currentTarget);
    $el.addClass('hidden');
    if ($el.hasClass('js-sort-name')) {
      this.$('.js-sort-time').removeClass('hidden');
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.sort = this.sortByDate;
    } else {
      this.$('.js-sort-name').removeClass('hidden');
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.sort = this.sortByName;
    }
    this.renderLibrary();
  }

  openAlignment(alignment: AlignmentAnalysis): void {
    analytics.track('alignment', 'open_saved_alignment');
    let tab = this.sequence!.fileState().findAlignmentTab(alignment);
    if (tab != null) {
      this.$el.find('.library-opening-spinner').removeClass('hidden');
      // In case activating the tab (ie rendering the alignment) is slow,
      // ensure that the spinner is shown by waiting an animation frame
      // before starting the intensive rendering.
      setTimeout(() => {
        this.sequence!.fileState().setIsWorkspaceSplit(false);
        tab!.set('active', true);
        this.$el.find('.library-opening-spinner').addClass('hidden');
        this.panelState!.trigger('close');
      }, 10);
    } else {
      this.$el.find('.library-opening-spinner').removeClass('hidden');
      tab = new SequenceAlignmentTabState({
        sequence: this.sequence,
        analysisId: alignment.id,
        alignmentId: alignment.get('apiId'),
      });
      this.sequence!.fileState().setIsWorkspaceSplit(false);
      this.buffers.addTab(tab);
      alignment
        .fetch({parse: true})
        .done((parsedAlignment) => {
          maybeShowBadAlignmentError(parsedAlignment, tab!);
          if (parsedAlignment?.alignments == null) {
            this.$el.find('.library-opening-spinner').addClass('hidden');
            return;
          }
          tab!.loadAnalysis(alignment);
          this.$el.find('.library-opening-spinner').addClass('hidden');
          this.panelState!.trigger('close');
        })
        .fail((res) => {
          notifications.notifyError(res);
          this.$el.find('.library-opening-spinner').addClass('hidden');
          tab!.close();
        });
    }
  }

  renderInProgress(): void {
    const alignmentsInProgress = this.panelState!.get('alignmentsInProgress');
    const els = alignmentsInProgress.map((progress: InProgressAlignment) =>
      this.alignmentProgressTemplate({
        algorithm: progress.get('algorithm'),
        numSequences: progress.get('numSequences'),
        created: DateUtil.readableTime(progress.get('created')),
      })
    );
    this.$('.in-progress').toggleClass('hidden', els.length === 0);
    this.$('.in-progress-library tbody').html(els);
  }

  renderLibrary(): void {
    const table = this.$el.find('table.alignment-library');
    const alignAnalyses = this.sequence!.get('analyses').filter(
      (analysis) => analysis.get('analysis_type') === SequenceAnalysisConstants.ALIGNMENT
    ) as Array<AlignmentAnalysis>;
    alignAnalyses.sort(this.sort);

    const checkDelete = (alignment: AlignmentAnalysis): SequenceAlignmentTabState | null =>
      this.sequence!.fileState().findAlignmentTab(alignment);
    const els = Array.from(alignAnalyses).map((alignAnalysis) => {
      const alignmentItemViewOptions: AlignmentItemViewOptions = {
        model: alignAnalysis,
        checkDelete,
      };
      return new AlignmentItemView(alignmentItemViewOptions).render().el;
    });
    if (els.length > 0) {
      // @ts-expect-error You can, but should not, pass elements to `JQuery.html`
      table.find('tbody').html(els);
    } else {
      // @ts-expect-error You can, but should not, pass strings to `JQuery.html`
      table.find('tbody').html($('<tr>').append('<td>').text('No sequence alignments'));
    }

    this.$el.find('.panel-library-row .delete').toggleClass('hidden', !_canDeleteAlignments(this.sequence!));
  }

  override render(): this {
    this.singlePanelTabReactRoot = renderSinglePanelTab(
      'sequence-alignments-tab',
      'sequence-alignments-panel',
      'Sequence Alignments',
      this.$('.panel-title')[0],
      this.singlePanelTabReactRoot
    );
    const $alignmentBtn = this.$el.find('.new-alignment-btn');
    // Cache the original text.
    if ($alignmentBtn.data('text') == null) {
      $alignmentBtn.data('text', $alignmentBtn.text());
    }
    $alignmentBtn.toggleClass(
      'disabled',
      !this.sequence!.allowFeatureEdits({ignoreLocked: true}) ||
        this.sequence!.isReallyBig() ||
        !this.sequence!.finalized()
    );
    if (showValueMessagingForSharedFile()) {
      $alignmentBtn.addClass('hide');
      this.toolbarSignupMessageReactRoot = renderToDOM(
        <ToolbarSignupMessage action="create an alignment" />,
        this.$el.find('.share-link-message-react-mount')[0],
        this.toolbarSignupMessageReactRoot
      );
    } else if (window.user == null) {
      $alignmentBtn.text('Sign up to create alignment').removeClass('disabled');
    } else if (!this.sequence!.allowFeatureEdits({ignoreLocked: true})) {
      $alignmentBtn.text('Create alignment disabled when read-only');
    } else {
      $alignmentBtn.text($alignmentBtn.data('text'));
      if (this.sequence!.isReallyBig()) {
        this.$('.new-alignment-btn').parent().tooltip({
          placement: 'bottom',
          container: 'body',
          title: 'Alignments are not currently supported for large sequences.',
        });
      } else if (!this.sequence!.finalized()) {
        this.$('.new-alignment-btn').parent().tooltip({
          placement: 'bottom',
          container: 'body',
          title: 'Finalize the sequence from the Assembly tab to enable alignments.',
        });
      } else {
        this.$('.new-alignment-btn').parent().tooltip('destroy');
      }
    }
    this.$('.js-alignment-sort').tooltip({
      container: 'body',
    });
    this.renderLibrary();
    this.renderInProgress();
    return this;
  }

  override remove(): Backbone.View<Backbone.Model> {
    unmountRootsAsync([this.singlePanelTabReactRoot, this.toolbarSignupMessageReactRoot], () => {
      this.singlePanelTabReactRoot = null;
      this.toolbarSignupMessageReactRoot = null;
      super.remove();
    });
    return this;
  }
}
AlignmentPanelView.initClass();

export default AlignmentPanelView;
